import { Paper, Typography } from '@mui/material'
import React from 'react'

function ErrorPaper({error} : any) {
  return (
    <Paper elevation={5} sx={{
        padding: 2,
        margin: {
            lg:'20px auto',
            sm:'5px auto'
        },
        alignItems: 'center',
        color: '#aa2222',
        backgroundColor: '#ffbbbb'
    }} >
        <Typography textAlign={'center'} > {error} </Typography>
    </Paper>
  )
}

export default ErrorPaper